<orbit-dialog-header [title]="data.title || 'SETTINGS.API_KEYS.DIALOG.TITLE' | translate" />

<div class="dialog-content">
  <form [formGroup]="form" class="api-key-form">
    <div class="form-group">
      <orbit-form-field
        [label]="'SETTINGS.API_KEYS.NAME' | translate"
        [name]="'name'"
        [controller]="name" />
    </div>

    <div class="form-group">
      <label for="expiresAt">{{ 'SETTINGS.API_KEYS.EXPIRES_AT' | translate }}</label>
      <orbit-date-picker
        [minDate]="minimumDate()"
        [todayLabel]="todayLabel()"
        [clearLabel]="clearLabel()"
        [monthNames]="monthNames()"
        [weekdayNames]="weekdayNames()"
        formControlName="expiresAt"
        id="expiresAt" />
    </div>

    @if (errorMessage()) {
      <div class="error-wrapper">
        <orbit-message
          [message]="errorMessage() ?? ''"
          [title]="'SHARED.ERRORS.ERROR_TITLE' | translate"
          [severity]="'error'" />
      </div>
    }
  </form>
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [label]="'SETTINGS.API_KEYS.CANCEL' | translate"
      (onClick)="onCancel()" />
    <orbit-button
      [icon]="saveIcon"
      [disabled]="!isConfirmation() && form.invalid"
      [label]="'SETTINGS.API_KEYS.SAVE' | translate"
      (onClick)="onSubmit()" />
  </div>
</orbit-dialog-footer>
